/* Dansk katalog for locale-invoice-list-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inv.title': 'Fakturaliste',
  'inv.titleHelp': 'Oversigt over fakturaer, tilbud, ordrebekræftelser og kreditnotaer for det valgte regnskabsår.',
  'inv.searchPh': 'Søg på fakturanummer, kunde eller beløb',
  'inv.searchHelp': 'Søg i listen på fakturanummer, kundenavn, fakturabeløb, nettobeløb, betalt beløb eller restbeløb.',
  'inv.downloadHelp': 'Download listen for den fane og det filter, du har valgt.',
  'inv.addHelp': 'Opret en ny faktura.',
  'inv.add': 'Ny faktura',
  'inv.filterHelp': 'Filtrér listen på status, dokumenttype, dato, periode, beløb og arkiv.',
  'inv.tabsHelpTitle': 'Dokumenttyper',
  'inv.tabsHelp': 'Skift mellem Faktura, Kladder, Tilbud/Ordrebekræftelse, Kreditnota og Salgsrapport.',
  'inv.listHelpTitle': 'Fakturalisten',
  'inv.listHelp': 'Hver række er ét dokument fra backend. Tryk på en række for detaljer og handlinger.',
  'inv.loading': 'Indlæser fakturaer',
  'inv.loadingSub': 'Henter data fra backend.',
  'inv.noMatch': 'Ingen resultater her',
  'inv.noMatchSub': 'Prøv en anden fane, eller nulstil filteret.',
  'inv.backToVouchers': 'Tilbage til transaktioner',
  'inv.type.invoice': 'Faktura',
  'inv.type.quote': 'Tilbud',
  'inv.type.orderConfirmation': 'Ordrebekræftelse',
  'inv.type.creditNote': 'Kreditnota',
  'inv.type.unknown': 'Dokument',
  'inv.tab.salesReport': 'Salgsrapport',
  'inv.importHistory.tab': 'Importeret historik',
  'inv.importHistory.loading': 'Henter importeret fakturahistorik …',
  'inv.importHistory.error': 'Kunne ikke hente importeret fakturahistorik.',
  'inv.importHistory.readOnly': 'Dette er skrivebeskyttet historik fra det tidligere system. Posterne påvirker ikke bogføring eller moms og har ingen fakturahandlinger i Plumme.',
  'inv.importHistory.documents': 'Dokumenter',
  'inv.importHistory.year': 'Importeret historik for {year}',
  'inv.importHistory.netSales': 'Nettosalg',
  'inv.importHistory.customers': 'Kunder',
  'inv.importHistory.creditNotes': 'Kreditnotaer',
  'inv.importHistory.netIncluded': 'Fratrukket nettosalg',
  'inv.importHistory.search': 'Søg på fakturanummer eller kunde',
  'inv.importHistory.empty': 'Ingen importerede fakturadetaljer for dette år',
  'inv.importHistory.emptySub': 'Importerede regnskabstal bruges stadig i rapporter og råd, når de findes.',
  'inv.importHistory.detailTitle': 'Detaljer fra importfilen',
  'inv.importHistory.dueDate': 'Forfaldsdato',
  'inv.importHistory.paidDate': 'Afregnet dato',
  'inv.importHistory.remaining': 'Udestående',
  'inv.importHistory.lines': 'Importerede linjer',
  'inv.importHistory.noLines': 'Kildesystemet leverede kun fakturatotaler for dette dokument.',
  'inv.importHistory.markSettled': 'Markér som afregnet',
  'inv.importHistory.reopenStatus': 'Åbn status igen',
  'inv.importHistory.manualSettledNote': 'Markeret som afregnet i Plumme uden bogføring.',
  'inv.importHistory.settledToast': 'Den importerede faktura er markeret som afregnet.',
  'inv.importHistory.reopenedToast': 'Den importerede faktura er åbnet igen.',
  'inv.importHistory.statusError': 'Kunne ikke opdatere den importerede faktura.',
  'inv.importHistory.sourceNote': 'Importeret fra tidligere system – dokumentet ligger i importfilen.',
  'inv.importHistory.creditReference': 'Importeret kreditnota fra tidligere system – krediterer faktura {number}.',
  'inv.importHistory.creditedReference': 'Importeret fra tidligere system · krediteret med kreditnota {number}',
  'inv.importHistory.reanalysisTitle': 'Importeret fakturahistorik skal analyseres igen',
  'inv.importHistory.reanalysisBody': 'Den gemte analyse er fra før kreditnotaer blev hentet fra separate kreditnota-ark. Kildedataene ændres ikke.',
  'inv.importHistory.reanalysisAction': 'Gå til genanalyse',
  'inv.importHistory.rowSource': 'Importeret fra tidligere system',
  'adv.sales.importedHistoryNote': 'Analysen kombinerer bogførte Plumme-fakturaer med skrivebeskyttet salgshistorik fra importen. Kreditnotaer er fratrukket. {coverage}',
  'adv.sales.importedTotalsCoverage': 'Importen indeholder fakturatotaler, men ikke produktlinjer for alle dokumenterne.',
  'adv.sales.importedLinesCoverage': 'Importen indeholder også fakturalinjer for dele af historikken.',
  'inv.tab.drafts': 'Kladder',
  'inv.filterDocType': 'Dokumenttype',
  'inv.filterArchive': 'Arkiv',
  'inv.filterSeeArchived': 'Se arkiverede',
  'inv.status.draft': 'Kladde',
  'inv.status.created': 'Ikke sendt',
  'inv.status.sent': 'Sendt',
  'inv.status.accepted': 'Accepteret',
  'inv.status.confirmed': 'Bekræftet',
  'inv.status.paid': 'Betalt',
  'inv.status.unpaid': 'Ikke betalt',
  'inv.status.overdue': 'Forfalden',
  'inv.status.credited': 'Krediteret',
  'inv.kpi.invoiceCount': 'Fakturaer',
  'inv.kpi.invoiceCount.help': 'Antal fakturaer, du har oprettet i det valgte år, uanset status.',
  'inv.kpi.revenue': 'Omsætning',
  'inv.kpi.revenue.help': 'Summen af alle fakturaer ekskl. moms i året.',
  'inv.kpi.notSent': 'Ikke sendt',
  'inv.kpi.notSent.help': 'Fakturaer, der ligger som kladder og venter på at blive sendt.',
  'inv.kpi.credited': 'Krediteret',
  'inv.kpi.credited.help': 'Antal kreditnotaer.',
  'inv.kpi.quotes': 'Tilbud',
  'inv.kpi.quotes.help': 'Antal tilbud i året.',
  'inv.kpi.accepted': 'Accepteret',
  'inv.kpi.accepted.help': 'Antal tilbud, som kunden har accepteret.',
  'inv.kpi.orders': 'Ordrebekræftelser',
  'inv.kpi.orders.help': 'Antal ordrebekræftelser i året.',
  'inv.kpi.creditNotes': 'Kreditnotaer',
  'inv.kpi.creditNotes.help': 'Antal kreditnotaer i året.',
  'inv.kpi.value': 'Værdi',
  'inv.kpi.value.help': 'Samlet værdi ekskl. moms for dokumenterne i denne fane.',
  'inv.kpi.amount': 'Beløb',
  'inv.kpi.amount.help': 'Samlet beløb ekskl. moms for kreditnotaerne.',
  'inv.kpi.sent': 'Sendt',
  'inv.kpi.sent.help': 'Antal dokumenter, der er sendt til kunden.',
  'inv.kpi.confirmed': 'Bekræftet',
  'inv.kpi.confirmed.help': 'Ordrebekræftelser, som kunden har bekræftet.',
  'inv.kpi.drafts': 'Kladder',
  'inv.kpi.drafts.help': 'Dokumenter, der endnu ikke er sendt.',
  'inv.kpi.potentialRevenue': 'Mulig omsætning',
  'inv.kpi.potentialRevenue.help': 'Samlet værdi af kladder, der kan blive sendt.',
  'inv.kpi.customers': 'Kunder',
  'inv.kpi.customers.help': 'Antal unikke kunder på kladderne.',
  'inv.kpi.history': 'Historik',
  'inv.kpi.history.help': 'Hvor længe den ældste kladde har ventet.',
  'inv.kpi.sub.totalYear': 'I alt i år',
  'inv.kpi.sub.exVat': 'Ekskl. moms',
  'inv.kpi.sub.waiting': 'Venter på dig',
  'inv.kpi.sub.creditNotes': 'Kreditnotaer',
  'inv.kpi.sub.started': 'Påbegyndte dokumenter',
  'inv.kpi.sub.uniqueCustomers': 'Unikke kunder',
  'inv.kpi.sub.oldestDraft': 'Ældste kladde',
  'inv.kpi.sub.noDrafts': 'Ingen kladder',
  'inv.kpi.sub.none': 'Ingen',
  'inv.kpi.sub.days': '{n} dage',
  'inv.kpi.sub.sentQuotes': 'Sendte tilbud',
  'inv.kpi.sub.accepted': 'Accepterede',
  'inv.kpi.sub.confirmed': 'Bekræftede',
  'inv.kpi.sub.notSent': 'Ikke sendt',
  'inv.kpi.sub.sent': 'Sendte',
  'inv.col.document': 'Dokument',
  'inv.col.invoice': 'Faktura',
  'inv.col.date': 'Dato',
  'inv.col.net': 'Netto',
  'inv.col.amount': 'Beløb',
  'inv.col.status': 'Status',
  'inv.col.number': 'Nr.',
  'inv.col.customer': 'Kunde',
  'inv.netInline': 'Netto {amount}',
  'inv.draftPlaceholder': 'KLADDE',
  'inv.detail.dueTitle': 'Forfald',
  'inv.detail.dueHelp': 'Den dato, dokumentet gælder til eller skal være betalt senest.',
  'inv.detail.statusHelp': 'Betalinger hentes fra bogførte PaymentEntry-poster. Tilbud og ordrebekræftelser viser gennemførelsesstatus.',
});
